<template>
  <nuxt-link
    class="flex items-center justify-center px-1.5 py-3 text-base leading-[19px] hover:bg-lightGray xs:px-[10px] sm:px-[15px] md:px-[25px]"
    :class="{
      'font-light': !isActive,
      'font-bold': isActive,
    }"
    :to="paginationLinkTo(page)"
    @click="scrollToTop"
  >
    <slot />
  </nuxt-link>
</template>

<script lang="ts">
export default defineComponent({
  name: 'PaginationButton',
  props: {
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isActive: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    page: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup() {
    const { paginationLinkTo } = useRouteHelpers()
    return {
      paginationLinkTo,
      scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
    }
  },
})
</script>
